import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import moment from "moment";

export const AverageFamilyIncome = [
  { description: "100,001 - Above" },
  { description: "100,000 - 50,001" },
  { description: "50,000 - 40,001" },
  { description: "40,000 - 30,001" },
  { description: "30,000 - 20,001" },
  { description: "10,000 below" },
];

export const StudentTypeList = [
  { description: "New Enrollee" },
  // { description: "Continuing Old (Regular)" },
//   { description: "Continuing Old (Irregular)" },
  { description: "Returning Student" },
  { description: "Transferee" },
];

export const GenderList = [{ description: "Male" }, { description: "Female" }];
export const HighSchoolList = [
  { description: "Senior High School" }, 
  { description: "High School" }, 
  { description: "ALS" }
];

export const CitizenshipList = [
  { description: "Filipino" }, 
  { description: "Others" }
];

export const AcademicList = [
  { description: "Undergraduate" },
  // { description: "Graduate" },
];

export const CivilStatusList = [
  { description: "Single" },
  { description: "Married" },
  { description: "Widowed" },
  { description: "Separated" },
];

export const ShowRequiredField = (message) => {
  return (
    <Typography component="div">
      <Box fontSize={14} color="error.main" display="flex" pt={1}>
        Required fields
      </Box>
    </Typography>
  );
};

export const ShowInvalidEmailFormat = () => {
  return (
    <Typography component="div">
      <Box fontSize={14} color="error.main" display="flex" pt={1}>
        Invalid email format
      </Box>
    </Typography>
  );
};

export const ShowInvalidCode = () => {
  return (
    <Box fontSize={14} color="error.main" display="flex" pt={1}>
      Invalid verification code
    </Box>
  );
};

export const SendEmailVerificationCode = (context, otp) => {

  const { contact } = context

  return new Promise(function (resolve, reject) {
    
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API}/api/email/otp`,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
      data: {
        email: contact.email,
        otp: otp,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        console.log(response);
      });

  });

};

export const SendEmailSuccess = (context, ano) => {

  const { contact } = context

  return new Promise(function (resolve, reject) {

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API}/api/email/admission/success`,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
      data: {
        email: contact.email,
        ano: ano,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        console.log(response);
      });

  });

};

export const GetRegion = (id) => {
  return new Promise(function (resolve, reject) {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API}/api/util/region`,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        console.log(response);
      });

  });
};

export const GetProvince = (id) => {
  var tmpUrl = "";
  if (id === "" || id === undefined) {
    tmpUrl = `${process.env.REACT_APP_API}/api/util/province`
  } else {
    tmpUrl = `${process.env.REACT_APP_API}/api/util/province?id=${id}`
  }

  return new Promise(function (resolve, reject) {
    axios({
      method: "get",
      url: tmpUrl,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        console.log(response);
      });

  });
};

export const GetCity = (id) => {
  var tmpUrl = "";
  if (id === "" || id === undefined) {
    tmpUrl = `${process.env.REACT_APP_API}/api/util/city`
  } else {
    tmpUrl = `${process.env.REACT_APP_API}/api/util/city?id=${id}`
  }

  return new Promise(function (resolve, reject) {
    axios({
      method: "get",
      url: tmpUrl,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        console.log(response);
      });

  });
};

export const GetBarangay = (id) => {

  var tmpUrl = "";
  if (id === "" || id === undefined) {
    tmpUrl = `${process.env.REACT_APP_API}/api/util/barangay`
  } else {
    tmpUrl = `${process.env.REACT_APP_API}/api/util/barangay?id=${id}`
  }

  return new Promise(function (resolve, reject) {
    axios({
      method: "get",
      url: tmpUrl,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        console.log(response);
      });

  });
};

export const GetAcademicYear = (database) => {
  return new Promise(function (resolve, reject) {
    var result = {
      year: `${process.env.REACT_APP_AY_YEAR}`,
      semester: `${process.env.REACT_APP_AY_SEMESTER}`,
      datefrom: `${process.env.REACT_APP_AY_DATEFROM}`,
      dateto: `${process.env.REACT_APP_AY_DATETO}`,
    }

    resolve(result);
  });
};

export const GetUndergraduateCourses = () => {
  return new Promise(function (resolve, reject) {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API}/api/util/undergraduate`,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        console.log(response);
      });

  });
};

export const GetGraduateCourses = () => {
  return new Promise(function (resolve, reject) {

    axios({
      method: "get",
      url: `${process.env.REACT_APP_API}/api/util/graduate`,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        console.log(response);
      });


  });
};

export const GetTracks = (database) => {
  return new Promise(function (resolve, reject) {
    var result = []
    result.push({
      "code": "acad", "description": "Academic", "strand": [
        { "description": "Accounting Business and Management (ABM)" },
        { "description": "General Academic Strand (GAS)" },
        { "description": "Humanities and Social Sciences (HUMSS)" },
        { "description": "Science, Technology, Engineering and Math (STEM)" }
      ]
    })

    result.push({
      "code": "tvl", "description": "Technical-Vocational-Livelihood (TVL)",
      "strand": [
        { "description": "Agri-Fishery Arts" },
        { "description": "Home Economics" },
        { "description": "Industrial Arts" },
        { "description": "Information and Communications Technology (ICT)" }
      ]
    }
    )

    result.push({ "code": "sports", "description": "Sports", "strand": [] })
    result.push({ "code": "arts", "description": "Arts and Design", "strand": [] })
    resolve(result);

  });
};

export const GetToken = () => {
  return new Promise(function (resolve, reject) {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API}/api/token`,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
      });
  });
};

export const GetSettings = (token) => {
  return new Promise(function (resolve, reject) {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API}/api/token`,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      data: token,
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((response) => {
        console.log(response);
      });
  });
};

export const HttpHeader = {
  "Content-type": "application/json",
  Accept: "application/json",
};

export const SendAttachment = (database, id, data) => {

  return new Promise(function (resolve, reject) {

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API}/api/admission/doc`,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      data: data,
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

export const GetAdmissionNumber = (context) => {
  const { database, personalInformation } = context;
  return new Promise(function (resolve, reject) {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API}/api/autonumber/an`,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      data: {
        student: `${personalInformation.lastName}, ${personalInformation.firstName} ${personalInformation.middleName} `,
      },
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

export const SendAdmission = (context, ano, aid) => {
  const {
    studentType,
    personalInformation,
    address,
    contact,
    school,
    others,
  } = context;

  const data = {
    _id: aid,
    ano: ano,
    semester: context.semester,
    year: context.year,
    studentType: studentType.studentType === null ? "" : studentType.studentType.description,
    academic: studentType.academic === null ? "" : studentType.academic.description,
    preferred: studentType.preferred === null ? "" : studentType.preferred.description,
    secondChoice: studentType.secondChoice === null ? "" : studentType.secondChoice.description,
    lastName: personalInformation.lastName.toUpperCase().trim(),
    firstName: personalInformation.firstName.toUpperCase().trim(),
    middleName: personalInformation.middleName.toUpperCase().trim(),
    maidenName: personalInformation.maidenName.toUpperCase().trim(),
    dateofBirth: personalInformation.dateofBirth,
    placeOfBirth: personalInformation.placeOfBirth,
    gender: personalInformation.gender === null ? "" : personalInformation.gender.description,
    civilStatus: personalInformation.civilStatus === null ? "" : personalInformation.civilStatus.description,
    religion: personalInformation.religion,
    citizenship: personalInformation.citizenship,
    region: address.region === null ? "" :  address.region.region_name,
    province: address.province === null ? "" :  address.province.province_name,
    city: address.city === null ? "" : address.city.city_name,
    barangay:  address.barangay === null ? "" : address.barangay.brgy_name,
    zipCode: address.zipCode,
    houseNo: address.houseNo,
    street: address.street,
    email: contact.email,
    mobileno: contact.mobileno,
    fathersName: contact.fathersName,
    fathersOccupation: contact.fathersOccupation,
    fathersAddress: contact.fathersAddress,
    fathersContactNo: contact.fathersContactNo,
    mothersName: contact.mothersName,
    mothersOccupation: contact.mothersOccupation,
    mothersAddress: contact.mothersAddress,
    mothersContactNo: contact.mothersContactNo,
    guardianName: contact.guardianName,
    guardianRelationship: contact.guardianRelationship,
    guardianAddress: contact.guardianAddress,
    guardianOccupation: contact.guardianOccupation,
    guardianContactNo: contact.guardianContactNo,
    averageFamilyIncome: contact.averageFamilyIncome === null ? "" : contact.averageFamilyIncome.description,
    shsName: school.shsName,
    shsAddress: school.shsAddress,
    lrn: school.lrn,
    shsTrack: school.shsTrack === null ? "" : school.shsTrack.description,
    shsStrand: school.shsStrand === null ? "" : school.shsStrand.description,
    shsInclusiveDate: school.shsInclusiveDate === null ? "" : school.shsInclusiveDate,
    collegeCourse: school.collegeCourse,
    collegeName: school.collegeName,
    collegeAddress: school.collegeAddress,
    collegeInclusiveDate: school.collegeInclusiveDate === null ? "" : school.collegeInclusiveDate,
    gradIntermediate: school.gradIntermediate,
    gradIntermediateYear: school.gradIntermediateYear,
    gradShs: school.gradShs,
    gradShsYear: school.gradShsYear,
    gradCollege: school.gradCollege,
    gradCollegeYear: school.gradCollegeYear,
    gradHighestYearCompleted: school.gradHighestYearCompleted,
    gradLastSchoolAttended: school.gradLastSchoolAttended,
    fa: others.fa,
    faSpecify: others.faSpecify,
    ig: others.ig,
    igSpecify: others.igSpecify,
    sp: others.sp,
    pwd: others.pwd,
    txnType: "online",
    txnDate: moment(new Date()).format("YYYYMMDDHHmmss"),
    txnStatus: 0,
    txnApprover: ""
  };

  return new Promise(function (resolve, reject) {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API}/api/admission`,
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      data: data,
      auth: {
        username: `${process.env.REACT_APP_USER}`,
        password: `${process.env.REACT_APP_PWD}`,
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

export const kPButton = {
  height: 42,
  borderRadius: 10,
  backgroundColor: "#e58822",
  color: "white",
};
